import { createAction, handleActions } from "redux-actions";
import _assign from "lodash/assign";
//
import { MODEL_GET, MODEL_SHOW } from "../models/actions";
import { REVIEWS_GET } from "./actions";
import Ctrl from "./controller";

// Reducer
const serverState = window.initialState;

const initialState = _assign(
  {
    entities: {},
    modelId: null,
    pages: {},
    noMores: {},
  },
  serverState.reviews
);

export default handleActions(
  {
    [MODEL_SHOW]: Ctrl.showModel,
    [MODEL_GET.FULFILLED]: Ctrl.getModelFulfilled,
    [REVIEWS_GET.PENDING]: Ctrl.getReviewsPending,
    [REVIEWS_GET.FULFILLED]: Ctrl.getReviewsFulfilled,
    [REVIEWS_GET.REJECTED]: Ctrl.getReviewsRejected,
  },
  initialState
);
